export default __webpack_public_path__ + "static/3-d7bb9e066896e94310bc6ef2a4751ebd.png";